import React from 'react';
import { Award, Shield, CheckCircle, Star } from 'lucide-react';

const TrustBadges = () => {
  const badges = [
    {
      name: "Licensed & Insured",
      description: "NYC Certified",
      icon: Shield,
      verified: true
    },
    {
      name: "5-Star Rated",
      description: "Customer Reviews",
      icon: Star,
      verified: true
    }
  ];

  return (
    <section className="py-16" style={{ background: 'var(--bg-page)' }}>
      <div className="container">
        <div className="text-center mb-10">
          <h2 className="heading-2 mb-3">Trusted & Certified</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Recognized by leading industry organizations
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {badges.map((badge, index) => {
            const IconComponent = badge.icon;
            return (
              <div 
                key={index}
                className="flex flex-col items-center text-center p-4 rounded-lg transition-transform hover:scale-105"
                style={{ background: 'var(--bg-section)' }}
              >
                <div 
                  className="w-16 h-16 rounded-full flex items-center justify-center mb-3"
                  style={{ background: 'var(--accent-wash)' }}
                >
                  <IconComponent size={28} style={{ color: 'var(--accent-text)' }} />
                </div>
                <h3 
                  className="font-semibold text-sm mb-1"
                  style={{ color: 'var(--text-primary)' }}
                >
                  {badge.name}
                </h3>
                <p className="caption" style={{ color: 'var(--text-secondary)' }}>
                  {badge.description}
                </p>
                {badge.verified && (
                  <div className="mt-2">
                    <span 
                      className="text-xs px-2 py-1 rounded-full"
                      style={{ background: 'var(--accent-wash)', color: 'var(--accent-text)' }}
                    >
                      Verified
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
